'use strict';

var CompFaresChartControlsBoardDirective = function CompFaresChartControlsBoardDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/comp-fares-chart-controls-board.html'),
    controller: 'CompFaresChartControlsBoardController',
    scope: {
      contextData: '='
    }
  };
};
CompFaresChartControlsBoardDirective.$inject = [];
module.exports = CompFaresChartControlsBoardDirective;